import { GiftCard } from 'services/checkout-service/models';

const calculatePendingAmountForGiftCards = (giftCards: GiftCard[], cartTotal?: number) => {
  if (!cartTotal || cartTotal <= 0) {
    return 0;
  }

  const sum = giftCards.reduce((currentSum: number, newCard: GiftCard) => {
    //  @ts-ignore
    // FIXME: Update response object after mocking & talk to Holden about lock_anount
    return (newCard.balance || 0) + currentSum;
  }, 0);

  return cartTotal - sum <= 0 ? 0 : cartTotal - sum;
}


export {
  calculatePendingAmountForGiftCards
}
